import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

function H5sysLoginGate() {
    const auth = useSelector((state) => state.login)

    return auth.isLog ? <Outlet /> : <Navigate to="/H5sysLogin" replace />
}

export default H5sysLoginGate